import React, { useRef } from "react";
import Modal from "react-responsive-modal";
import { useGetEmployeeDocumetDetailsView } from "../../queries/systemPolicyQueries";
import { DOCUMENT_APPROVAL_STAUS } from "../../Consts/consts";
import useFetchFile from "../../hooks/useFetchFile";
import { SYSTEM_POLICY_FILES_URL } from "../../Consts/filePathConst";
import { FaDownload } from "react-icons/fa";
import { toast } from "react-toastify";

const DocumentDetailsModal = ({ documentId, onClose }) => {
  const { data: document, isLoading } = useGetEmployeeDocumetDetailsView({
    document_id: documentId,
  });
  const getFile = useFetchFile();
  const downloadLinkRef = useRef(null);

  const docDetails = document?.data?.[0] || {};
  const {
    files = [],
    created_by = "N/A",
    document_type = "N/A",
    approved_by = "N/A",
    approved_date,
    approval_status_id,
    document_subject,
    description
  } = docDetails;

  const approvalStatusId = Number(approval_status_id);
  const approvedStatusLabel = {
    [DOCUMENT_APPROVAL_STAUS.approved]: "Approved",
    [DOCUMENT_APPROVAL_STAUS.declined]: "Declined",
    [DOCUMENT_APPROVAL_STAUS.inProcess]: "In-Process",
    [DOCUMENT_APPROVAL_STAUS.readyForApproval]: "Ready for approval"
  }[approvalStatusId] || "Pending";

  const handleDownloadFile = async (file) => {
    if (!file || !file.src) {
      toast.error("No file available for download");
      return;
    }

    try {
      const url = await getFile(`${SYSTEM_POLICY_FILES_URL}/${file.src}`);
      if (!url) throw new Error("Failed to get file URL");

      const a = downloadLinkRef.current;
      a.href = url;
      a.download = file.file_name;
      a.click();

      toast.success(`Downloaded: ${file.file_name}`);
    } catch (err) {
      console.error(err);
      toast.error("Download failed");
    }
  };

  if (isLoading) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
        <div className="bg-white p-6 rounded-lg w-96 shadow-lg">Loading...</div>
      </div>
    );
  }

  return (
    <Modal open={documentId !== null} onClose={onClose} center>
      <div className="flex flex-col w-[600px] gap-3">
        <div className="flex justify-between items-center">
          <h1 className="font-medium text-xl text-gray-800">
            Document Details
          </h1>
          <button onClick={onClose}></button>
        </div>

        <table className="w-full border-collapse border border-gray-300">
          <tbody>
            <tr>
              <td className="border border-gray-300 p-2 font-semibold">
                Employee Name
              </td>
              <td className="border border-gray-300 p-2">{created_by}</td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-2 font-semibold">Document Type</td>
              <td className="border border-gray-300 p-2">{document_type}</td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-2 font-semibold">
                Document Subject
              </td>
              <td className="border border-gray-300 p-2">{document_subject}</td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-2 font-semibold">
                Document Description
              </td>
              <td className="border border-gray-300 p-2">{description}</td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-2 font-semibold">
                Updated By
              </td>
              <td className="border border-gray-300 p-2">{approved_by}</td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-2 font-semibold">
              Updated Date
              </td>
              <td className="border border-gray-300 p-2">
                {approved_date
                  ? new Date(approved_date).toLocaleDateString()
                  : "N/A"}
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-2 font-semibold">Approval Status</td>
              <td className="border border-gray-300 p-2">{approvedStatusLabel}</td>
            </tr>

            {/* Files Section */}
            <tr>
              <td className="border border-gray-300 p-2 font-semibold">Files</td>
              <td className="border border-gray-300 p-2">
                {files.length > 0 && approvalStatusId === DOCUMENT_APPROVAL_STAUS.approved ? (
                  <ul className="flex flex-col gap-2">
                    {files.map((file, idx) => (
                      <li key={idx} className="flex items-center gap-2">
                        <span>{file.file_name}</span>
                        <FaDownload
                          className="cursor-pointer"
                          onClick={() => handleDownloadFile(file)}
                        />
                      </li>
                    ))}
                  </ul>
                ) : (
                  <span>No document uploaded</span>
                )}
              </td>
            </tr>
          </tbody>
        </table>

        <a ref={downloadLinkRef} style={{ display: "none" }}>
          Download
        </a>

        <div className="flex items-center justify-end gap-3 mt-4">
          <button onClick={onClose} className="btn btn--border">
            Close
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DocumentDetailsModal;
